import React,{useEffect, useState} from "react";
import "./home.scss";
import { mykBranding, HomeBanner1, HomeBanner2, HomeBanner3, HomeBanner4, locator } from "../../assets/images";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";
import { EmailToLink, REGION } from "../../const/linksection";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Spinner, SpinnerSize } from '@fluentui/react';

const HomeComponent = (props: any) => {

    const { copyRightDetails, landingPageDetails, myKomatsuRegion } = props;
    const [locDistributorVisible, setLocDistributorVisible] = useState<boolean>(false);
    const [spinnerState, setSpinnerState] = useState<boolean>(false);

  const imgUrl = props?.cdnURL;

  const windowHcalc = window.innerHeight - 100;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  };
  const sliderlist: any = [
      {
          key: 1,
          img: imgUrl + HomeBanner1,
      },
      {
          key: 2,
          img: imgUrl + HomeBanner2,
      },
      {
          key: 3,
          img: imgUrl + HomeBanner3,
      },
      {
          key: 4,
          img: imgUrl + HomeBanner4,
      },
  ];

  const locationpageName = useLocation().pathname;

    const getComponetsName = () => {
        let substringlocationpageName = (locationpageName != undefined && locationpageName != "") ? locationpageName.substring(1, locationpageName.length) : "";
        if (substringlocationpageName == "landingue") {
           document.body.classList.add("landingPage-open");
        } 
    };

    useEffect(()=>{
      getComponetsName()
    }, []);

    const LogintoApp = () => {
        window.location.href = "/auth/index?returnUrl=";
    }

    const toggleLocatorDistributor = () => {
        setLocDistributorVisible(!locDistributorVisible);
        setSpinnerState(true);
        document.body.classList.toggle('komatsu_modal-open');
        document.body.classList.remove('myUtilizationTogglePopup');
    }

    const hideLoader = () => {
        setSpinnerState(false);
    }

    const spinnerStyles = {
        circle: {
            borderColor: '#0e1271 #ced0f1 #ced0f1'
        }
    }


  return (
    <>
      <div className="container-fluid header-wrapper landing-header">
        <div className="row">
          <div className="col-12 col-lg-4">
            <div className="leftList">
                <img src={imgUrl + mykBranding} alt="logo" className="logoImg" />
            </div>
          </div>
          <div className="col-12 col-lg-8">
            <div className="rightList">
              <ul className="inlineList">
                {(myKomatsuRegion == REGION.Europe) && (
                    <li>
                        <a href="./" onClick={(e: any) => { e.preventDefault(); window.open('mailto:' + EmailToLink.Email + '?subject=' + EmailToLink.Subject) }}
                            title="Customer support">
                            <em className="icon-notificationuser"></em>
                        </a>
                    </li>
                )}
                <li>
                  <div className="btnview">
                      <button className="login-btn" title="Login" onClick={LogintoApp}>Login <span className="fa fa-sign-in ml-2"></span></button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="navigation-wrapper landing-navigation">
        <span className="fa fa-bars menuBars" />
        <nav className="headerNavigation">
          <ul className="float-sm-left">
            <li>
              <a href="https://www.komatsu.com/en/services-and-support/equipment-monitoring-and-analysis/my-komatsu/" 
                 target="_blank">About My Komatsu</a>
            </li>
            <li>
                <a href={landingPageDetails?.smartConstructionUrl}
                target="_blank">Smart Construction</a>
            </li>
          </ul>
          <ul className="float-sm-right">
            <li>
                 <img src={imgUrl + locator} alt="Locate" className="locationIcon"/>
                <a href={landingPageDetails?.dealerUrl} className="plainText" /*onClick={(e: any) => openLocDistributor(e)}*/ 
                 target="_blank">Locate a distributor</a>
            </li>
          </ul>
        </nav>
      </div>
      <div className="wrapperHDH" style={{ minHeight: windowHcalc + "px" }}>
          <div className="landingmain-wrapper">
          <div className="row">
            <div className="col-lg-12">
                <Slider {...settings}>
                  {sliderlist.map(
                    (
                      item: {
                        key: string | number;
                        img: any;
                      },
                      index: number
                    ) => (
                          <img
                        key={item?.img}
                        src={item?.img}
                        alt="bannerImg"
                        className="bannerImg"
                      />
                    )
                  )}
                </Slider>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer-wrapper landing-footer">
        <span className="leftText">
          {copyRightDetails?.Text}
        </span>
        <span className="centerText">
          {" "}
          <div> 
             <a href={landingPageDetails?.privacyPolicy} target="_blank" title="Privacy Policy">Privacy policy</a> | {" "}
             <a href={landingPageDetails?.termsOfUse} className="termsWrapper" title="Terms of Use">Terms of Use</a>
          </div>
        </span>
        <span className="rightText">{copyRightDetails?.Version} - {copyRightDetails?.VersionDate}</span>
      </footer>
      {
            locDistributorVisible && (
                <Dialog
                    title="Find Your Distributor"
                    onClose={toggleLocatorDistributor}
                    width={800}
                    className='fcModal'
                >
                    <div className='row'>
                        <div className='col-12'>
                            <div className="HeadTitle my-2">Find your distributor</div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <div id="fcLetterDiv">
                                {spinnerState ? <Spinner size={SpinnerSize.large} styles={spinnerStyles} /> : ''}
                                <iframe src={landingPageDetails?.dealerUrl} title="Find your distributor" onLoad={hideLoader}></iframe>
                            </div>
                        </div>
                    </div>
                </Dialog>
        )}
    </>
  );
};

export default HomeComponent;

